import { currency } from '@frontend/design-system';
import { CareCreditPatientData, CareCreditPatientStatus } from '../types/care-credit.types';

export type UseDisplayCareCreditOptions = {
  decimals?: number;
  showLastX?: number;
};

const maskId = (string: string, showLastX = 4) => {
  return string.slice(0, -showLastX).slice(0, 10).replace(/./g, '*') + string.slice(-showLastX);
};

export const useDisplayCareCreditData = (
  { amount, status, careCreditPersonId }: Partial<CareCreditPatientData> = {},
  { decimals = 0, showLastX = 4 }: UseDisplayCareCreditOptions = {}
) => {
  const statusMap: Record<CareCreditPatientStatus, string> = {
    approved: 'Active',
    'pre-approved': 'Pending',
    'not-enrolled': 'Not Enrolled',
    declined: 'Declined',
    'unknown-or-error': 'Error',
  };

  if (!amount || !status || !careCreditPersonId) {
    return {
      formattedAmount: '',
      formattedStatus: '',
      formattedCareCreditPersonId: '',
    };
  }

  return {
    formattedAmount: currency(amount, { decimals }),
    formattedStatus: statusMap[status],
    formattedCareCreditPersonId: maskId(careCreditPersonId, showLastX),
  };
};
